import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Form, Input, Col } from 'antd';

function HiddenField({
  data,
  index,
  value,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-field', 'hidden-input', className);

  return (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data.name + index + '-item'}
        name={data.name}
        hidden={true}
        className={data.name + '-wrapper'}
        initialValue={value || ''}
        rules={[
          {
            required: false,
            message: '',
          },
        ]}
      >
        <Input />
      </Form.Item>
    </Col>
  );
};

HiddenField.defaultProps = {
  value: '',
  index: 1,
};

HiddenField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(HiddenField);